/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestStatDto } from '../../models/contents-request-stat-dto';

export interface ContentsRequestControllerGetStat$Params {
  gte: string;
  lte: string;
}

export function contentsRequestControllerGetStat(http: HttpClient, rootUrl: string, params: ContentsRequestControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestStatDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestControllerGetStat.PATH, 'get');
  if (params) {
    rb.query('gte', params.gte, {});
    rb.query('lte', params.lte, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestStatDto>;
    })
  );
}

contentsRequestControllerGetStat.PATH = '/api/contents-request/stat';
